import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { ActivatedRoute } from "@angular/router";
import { LoggerServiceRef } from "@bfx/logger/dist/src/LoggerService";

const LOGLEVEL_TRACE = "TRACE";
const LOGLEVEL_DEBUG = "DEBUG";
const LOGLEVEL_INFO = "INFO";

export class ConfiguredLogger {
  private enableTraceLog: boolean = false;
  private enableDebugLog: boolean = false;
  private enableInfoLog: boolean = false;

  private logPrefix: string;

  public constructor(private logger: LoggerServiceRef) {}

  public initialiseLogging(cmdLine: ActivatedRoute, loggingType: string, logPrefix: string) {
    this.logPrefix = logPrefix;
    if (cmdLine != null) {
      cmdLine.params.subscribe((data) => {
        const id = data["id"];
        logger.out.info(`ConfiguredLogger: reading value of params ${id}`);
      });

      let loggingLevel: string = cmdLine.snapshot.queryParamMap.get(loggingType);
      if (null != loggingLevel) {
        switch (loggingLevel) {
          case LOGLEVEL_TRACE:
            this.enableTraceLog = true;
            this.enableDebugLog = true;
            this.enableInfoLog = true;
            break;
          case LOGLEVEL_DEBUG:
            this.enableDebugLog = true;
            this.enableInfoLog = true;
            break;
          case LOGLEVEL_INFO:
            this.enableInfoLog = true;
            break;
        }
      }
    }
  }

  public infoEnabled(): boolean {
    return this.enableInfoLog;
  }

  public error(message?: any, ...optionalParams: any[]) {
    logger.out.error(`${this.logPrefix}: ${message}`, optionalParams);
  }

  public trace(message?: any, ...optionalParams: any[]) {
    if (this.enableTraceLog) {
      console.trace(`${this.logPrefix}: ${message}`, optionalParams);
    }
  }

  public debug(message?: any, ...optionalParams: any[]) {
    if (this.enableDebugLog) {
      console.debug(`${this.logPrefix}: ${message}`, optionalParams);
    }
  }

  public info(message?: any, ...optionalParams: any[]) {
    if (this.enableInfoLog) {
      logger.out.info(`${this.logPrefix}: ${message}`, optionalParams);
    }
  }
}
